import { defineStore } from 'pinia'
import '@/helpers/time'
import Streak from '@/models/streak'

export const useStreakStore = defineStore('streak', {
  state: () => ({ streakObject: undefined }),
  getters: {
    async load() {
      await Streak.get()
    },
    // Returns the streak array.
    streak() {
      return this.streakObject?.streak
    },
    // Returns true if the streak array exists.
    // TODO: Update this to use active field (since deativate returns streak),
    // because in future we might want to show a record of inactive streaks.
    active() {
      return this.streakObject?.streak ? true : false
    },
    // Returns true if the streak just started and no days have elapsed yet.
    dayOne() {
      return this.streakObject?.streak[0].completed === null
    },
    // Days left to complete in the streak.
    daysLeft() {
      return this.streakObject?.streak.filter(s => s.completed === null).length
    },
    // How many days are completed in the streak
    completedDays() {
      return this.streakObject?.streak.filter(s => s.completed === true).length
    },
    // How many days are in the streak
    days() {
      return this.streakObject?.streak.length
    },
    dateRange() {
      return {
        start: new Date(this.streakObject?.streak[0].date),
        end: new Date(this.streakObject?.streak[this.days - 1].date),
      }
    },
    // Returns true if today's streak is completed.
    todayCompleted() {
      const today = new Date()
      return this.streakObject?.streak.find(s => {
        let x = new Date(s.date)
        return x.format() === today.format()
      })?.completed === true
    },
  },
  actions: {
    update(streak) {
      if (!(streak instanceof Streak)) {
        throw new Error('Update must be a Streak object.')
      }
      this.streakObject = streak
    },
    deactivate() {
      this.streakObject.deactivate()
      this.streakObject = undefined
    }
  },
})